import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { UtilsService } from '../utils/utils.service';
import { BehaviorSubject } from 'rxjs-compat';

@Injectable({
	providedIn: 'root',
})
export class DashboardService {
	constructor(
		private http: HttpClient,
		private utils: UtilsService,
	) {}

	private onlineUsersCountSource = new BehaviorSubject<number>(0);

	onlineUsersCount$ = this.onlineUsersCountSource.asObservable();

	setOnlineUsersCount(count: number) {
		this.onlineUsersCountSource.next(count);
	}

	getUsersActivity(payload) {
		const url = `${environment.api}dashboard/users_activity`;
		const formData = this.utils.jsonToFormData(payload);

		return this.http.post(url, formData);
	}

	getDashboardStats() {
		const url = `${environment.api}ringcentral/get_dashboard_stats`;
		return this.http.get(url);
	}
}
